/**
 * @namespace transat/parameters
 */
import { hFeSocCongesTypeComptage } from '~/stores/transat/business-helpers'
import { concatAll } from '~/utils/lib/core/prelude'

/**
 * @enum {typeof WORK_DAY_TYPE[keyof typeof WORK_DAY_TYPE]}
 * @readonly
 */
export const WORK_DAY_TYPE = /** @type {const} */ ({
  WORKDAY: 'normal-workday',
  NON_HOLIDAY: 'non-holiday',
})
/** @type {(workday_type: WORK_DAY_TYPE) => hFeSocCongesTypeComptage} */
export const workDayTypeToComptage = workday_type => {
  switch (workday_type) {
    case WORK_DAY_TYPE.WORKDAY: return hFeSocCongesTypeComptage.OUVRES
    case WORK_DAY_TYPE.NON_HOLIDAY: return hFeSocCongesTypeComptage.OUVRABLES
  }
}
/** @type {(workday_type: WORK_DAY_TYPE) => string} */
export const printWorkDayType = workday_type => {
  const type_comptage = workDayTypeToComptage(workday_type)
  // (enum value is already a pretty print)
  return type_comptage
}

export const getMainRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ code_societe
  ) => concatAll([
    `/data/${structure_id}`,
    `/conges`,
    `/parameters`,
    `?company=${encodeURIComponent(code_societe)}`
  ])


export const getMiscLeaveRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ code_societe
  ) => concatAll([
    `/data/${structure_id}`,
    `/conges`,
    `/parameters/misc-leaves`,
    `?company=${encodeURIComponent(code_societe)}`
  ])


export const getCpRttRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ code_societe
  ) => concatAll([
    `/data/${structure_id}`,
    `/conges`,
    `/parameters/cp-rtt`,
    `?company=${encodeURIComponent(code_societe)}`
  ])


export const getCalendarRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ code_societe
  ) => concatAll([
    `/data/${structure_id}`,
    `/conges`,
    `/parameters/calendar`,
    `?company=${encodeURIComponent(code_societe)}`
  ])



